import { render, staticRenderFns } from "./IndustrySolutions_phone.vue?vue&type=template&id=6cd777e9&scoped=true&"
import script from "./IndustrySolutions_phone.vue?vue&type=script&lang=js&"
export * from "./IndustrySolutions_phone.vue?vue&type=script&lang=js&"
import style0 from "./IndustrySolutions_phone.vue?vue&type=style&index=0&id=6cd777e9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cd777e9",
  null
  
)

export default component.exports